import { Box, Stack } from '@mui/material';
import { isEqual } from 'lodash';
import { useLayoutComponentEditorStore } from './useLayoutComponentEditorStore';
import { LayoutComponentEditorContent } from './LayoutComponentEditorContent';
import { RenderDynamicHook, useSubEditorProps } from './Support';
import { ILayoutComponentEditorProps } from './LayoutComponentEditor.types';

export const LayoutComponentEditor = (props: ILayoutComponentEditorProps) => {
  const subEditorProps = useSubEditorProps(props);
  const subEditor = useLayoutComponentEditorStore((s) => s.getSubEditor(), isEqual);

  return (
    <RenderDynamicHook hook={subEditor?.useSubEditor} args={subEditorProps}>
      {(customEditor) => (
        <Stack flex={1} overflow="auto" height="100%">
          {customEditor ? (
            <Box p={2}>
              <Stack direction="column" spacing={2}>
                {customEditor.editors}
              </Stack>
            </Box>
          ) : (
            <LayoutComponentEditorContent {...props} />
          )}
        </Stack>
      )}
    </RenderDynamicHook>
  );
};
